import type { BigNumber } from "../BigNumber.js";
import type { DisplayMode } from "../types.js";
import { ShortScaleDisplayMode } from "./powerOfThousand.js";

const SHORT_SCALE_FALLBACK = new ShortScaleDisplayMode();

/**
 * 동양 약어(10^4-base) 표기 — 내부 1000-base를 log10 기반으로 10^4 그룹으로 rebasing.
 *   totalDigits = log10(|mantissa|) + 3·exponent
 *   exp4        = floor(totalDigits / 4)          (10^4 그룹 인덱스)
 *   displayRaw  = 10^(totalDigits − 4·exp4)       (∈ [1,10000))
 * 1만 미만은 정수 표기, 단위표(17개) 소진(10^72 이상)은 short-scale fallback.
 */
export class MyriadDisplayMode implements DisplayMode {
  constructor(private readonly units: readonly string[]) {}

  format(value: BigNumber, decimals: number): string {
    if (value.isZero()) return "0";
    const totalDigits = value.log10();
    if (totalDigits < 4) return Math.round(value.toNumber()).toString();
    const exp4 = Math.floor(totalDigits / 4);
    if (exp4 > this.units.length) return SHORT_SCALE_FALLBACK.format(value, decimals);
    const sign = value.isNegative() ? -1 : 1;
    const displayRaw = sign * Math.pow(10, totalDigits - 4 * exp4);
    return displayRaw.toFixed(decimals) + this.units[exp4 - 1];
  }
}
